import { DateTime } from "luxon";

const RELATIVE_DATE_CUTOFF_MILLIS = 1000 * 60 * 60 * 24;

export default function formatMessageTime(timeMillis: number): string {
  if (Date.now() - timeMillis < RELATIVE_DATE_CUTOFF_MILLIS) {
    return DateTime.fromMillis(timeMillis).toRelative() || "";
  }

  return DateTime.fromMillis(timeMillis).toLocaleString(
    DateTime.DATETIME_SHORT
  );
}
